import i18n from './i18n';

export const FlashDefinition = {
  UpdateAccountSuccess: {
    context: [{ detail: i18n.flashSavedSuccess }],
    status: 'success',
  },
};
